import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Insured } from "src/shared/models";
import { EpsContractor } from "src/containers/eps/domain/models/contractor";
import { EpsEndpoints } from "src/containers/eps/core/endpoints";
import { replaceString } from "src/libs/replace-string";
import { HttpClient } from "src/infra/http/client";
import type {
    GetEpsContractorParams,
    GetEpsHolderParams,
} from "src/containers/eps/core/types";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class EpsService {
    constructor(@inject("HttpClient") private http: HttpClient) {
        this.getContractor = this.getContractor.bind(this);
        this.getInsureds = this.getInsureds.bind(this);
    }

    @autoBind
    getContractor({
        planNumber,
        contractorId,
        userIdentity,
    }: GetEpsContractorParams): Observable<EpsContractor> {
        const url = replaceString(EpsEndpoints.GetContractor, {
            ":userIdentity": userIdentity,
            ":contractorId": contractorId,
            ":planNumber": planNumber,
        });
        return this.http
            .getJSON<Record<string, any>>(url, { isPublicRequest: false })
            .pipe(map((data) => EpsContractor.fromJson(data)));
    }

    @autoBind
    getInsureds({
        insuredCode,
        userIdentity,
    }: GetEpsHolderParams): Observable<Array<Insured>> {
        const url = replaceString(EpsEndpoints.GetHolder, {
            ":insuredCode": insuredCode,
            ":userIdentity": userIdentity,
        });
        return this.http
            .getJSON<Array<Record<string, any>>>(url, {
                isPublicRequest: false,
            })
            .pipe(map((data) => data.map((x) => Insured.fromJson(x))));
    }
}
